import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CircleUserRound } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

import { Button } from '../../../components/ui/button.tsx';
import ParentHeader from '../../../components/dashboard/layout/parentHeader';
import useParent from '../../../hooks/useParent';
import { LoadingSpinner } from '../../../components/ui/loading-spinner.tsx';

const SelectChild = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/parent/settings', { state: { label: 'Account Information' } });
  };
  const {
    parentChildren,
    setCurrentChild,
    refetchChildren,
    isChildrenLoading,
  } = useParent();

  const handleSelectChild = (child) => {
    setCurrentChild(child, {
      onSuccess: () => {
        navigate('/parent/dashboard');
      },
    });
  };

  useEffect(() => {
    if (!parentChildren) {
      refetchChildren();
    }
  }, [parentChildren, refetchChildren]);

  return (
    <div>
      <ParentHeader />
      {parentChildren &&
      parentChildren.data &&
      parentChildren.data.length > 0 ? (
        <div className="flex flex-col items-center justify-center px-5">
          <p className="mb-5 mt-28 md:text-2xl text-[#555555] text-lg">
            Select Child Profile
          </p>
          <div className="flex justify-between gap-x-10 flex-col md:flex-row flex-wrap">
            {parentChildren.data.map((child, index) => (
              <motion.div
                key={index}
                className="flex flex-col items-center mb-5 cursor-pointer"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  ease: 'easeOut',
                  delay: index * 0.2,
                }}
                onClick={() => handleSelectChild(child)}
              >
                {child.photoUrl ? (
                  <img
                    src={child.photoUrl}
                    alt="Child"
                    className="md:w-48 md:h-48 h-24 w-24 object-cover mb-3"
                  />
                ) : (
                  <div className="md:w-48 md:h-48 h-24 w-24 mb-3 flex items-center justify-center bg-purple-100 text-purple-700 rounded-full">
                    <p className="md:text-8xl text-3xl">
                      {child.firstName[0]}
                      {child.lastName[0]}
                    </p>
                  </div>
                )}
                <p className="md:text-lg text-[#555555] text-sm">
                  {child.firstName}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      ) : (
        <AnimatePresence>
          {isChildrenLoading ? (
            <div className="h-[90vh] flex flex-col items-center justify-center">
              <LoadingSpinner className="w-28 h-28" />
              <span className="font-light mt-2">Loading...</span>
            </div>
          ) : (
            <motion.div
              className=" h-[90vh] flex flex-col items-center justify-center"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, ease: 'easeInOut' }}
            >
              <CircleUserRound size={300} strokeWidth={0.75} color="#8d8c8c" />

              <p className="text-xl mb-3">Your child is not registered yet</p>
              <p className="text-base text-gray-500 mb-5">
                Would you like to setup your profile?
              </p>
              <Button onClick={handleClick} variant={'default'}>
                Edit Profile
              </Button>
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </div>
  );
};

export default SelectChild;
